import { Component, Input } from '@angular/core';
import { FormGroup }        from '@angular/forms';
import { ElementBase } from './elementBase';


@Component({
  selector: 'form-element',
  templateUrl: './formElement.html'
})
export class DynamicFormElementComponent {
  @Input() element: ElementBase<any>;
  @Input() form: FormGroup;
  get isValid() { return this.form.controls[this.element.key].valid; }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/form/elements/formElement.ts